export default __webpack_public_path__ + "static/media/wa_0002.31783ab5.jpg";